import { render, staticRenderFns } from "./Sociedades.vue?vue&type=template&id=86a94782"
import script from "./Sociedades.vue?vue&type=script&lang=js"
export * from "./Sociedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports